import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { addFlashMessage } from '~/store/flashMessageSlice'

/**
 * Component that handles legacy URL-based flash messages by converting them to Redux actions.
 * This provides a bridge between backend redirects that use ?msg= parameters
 * and the new Redux-based flash message system.
 */
export function FlashMessageUrlHandler(): null {
  const dispatch = useDispatch()
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    const msg = searchParams.get('msg')

    if (msg) {
      // Convert URL msg parameter to Redux flash message
      dispatch(addFlashMessage({ type: 'success', message: msg }))

      // Clean up the URL parameter using React Router
      const newSearchParams = new URLSearchParams(searchParams)
      newSearchParams.delete('msg')
      setSearchParams(newSearchParams, { replace: true })
    }
  }, [searchParams, dispatch, setSearchParams])

  // This component doesn't render anything, it just handles URL-to-Redux conversion
  return null
}
